import React, { useState } from 'react';
import logo from '../../assets/logo.webp';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import playstore from '../../assets/googleplay.webp';
import appstore from '../../assets/appstore.webp';

const Header = () => {
  const location = useLocation();
  return (
    <Navbar variant="light" expand="lg">
      <Container>
        <Navbar.Brand href="/">
          <img className='logo'
            src={logo}
            alt="mechanic-hunt"
             // Adjust size as needed
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className='justify-content-end'>
          <Nav className="cust-nav align-items-center">
            <Nav.Link href="/" className={location.pathname === '/home' ? 'active' : ''}>Home</Nav.Link>
            <Nav.Link href="/about" className={location.pathname === '/about' ? 'active' : ''}>About</Nav.Link>
            <Nav.Link href="/blogs" className={location.pathname === '/blogs' ? 'active' : ''}>Blog</Nav.Link>
            <Nav.Link href="/plans" className={location.pathname === '/plans' ? 'active' : ''}>plans</Nav.Link>
            <Nav.Link href="/contact" className={location.pathname === '/contact' ? 'active' : ''}>Contact</Nav.Link>
            <Nav.Link className='app_btn' href="/contact"> Post Your Ad </Nav.Link>
            <Nav.Link className='highlight_call' href="tel:+18008057820">
              {/* <span>Call For More Details</span>  */}
               +1 (800) 805-7820
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
